import type { Translations } from '../../types'

const titlesMessages: Translations = {
  "titles.dashboard": "Dashboard",
  "titles.supportRequests": "Richieste assistenza",
  "titles.supportInbox": "Ticket assistenza",
  "titles.notifications": "Centro Notifiche",
  "titles.slider": "Gestione slider",
  "titles.media": "Media",
  "titles.plugins": "Gestione Plugin",
  "titles.languages": "Lingue",
  "titles.pages": "Pagine",
  "titles.siteSettings": "Site settings",
  "titles.site.branding": "Brand e homepage",
  "titles.themes": "Theme manager",
  "titles.site.footer": "Footer",
  "titles.site.legal": "Privacy e policy",
  "titles.site.contact": "Contatti e social",
  "titles.site.emailSettings": "Configurazione email",
  "titles.site.emailTemplates": "Template email",
  "titles.site.emailLogs": "Log email",
  "titles.site.payments": "Pagamenti",
  "titles.site.botProtection": "Protezione Bot",
  "titles.systemStatus": "Stato sistemi",
  "titles.updates": "Updates",
  "titles.featureFlags": "Feature Flags",
  "titles.auditLogs": "Audit log",
  "titles.auditTrail": "Audit trail globale",
  "titles.builder": "Compositore contenuti",
  "titles.menu": "Menu homepage",
  "titles.shop.products": "Prodotti",
  "titles.shop.categories": "Categorie",
  "titles.shop.orders": "Ordini",
  "titles.customer.ordersInvoices": "Ordini e fatture",
  "titles.customer.profile": "Profilo",
  "titles.customer.addresses": "Indirizzi",
  "titles.shop.customers": "Clienti",
  "titles.shop.migrations": "Migrazioni shop",
  "titles.shop.productTypes": "Product Models",
  "titles.profile.contact": "Account",
  "titles.profile.preferences": "Preferenze",
  "titles.profile.smtp": "Configurazione email (SMTP)",
  "titles.profile.security": "Sicurezza account",
  "titles.profile.sessions": "Sessioni e dispositivi",
  "titles.profile.team": "Team e ruoli",
  "titles.profile.danger": "Privacy"
}

export default titlesMessages
